// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"b87c3019","480":"b9690fc9","972":"7e1f9486"}[chunkId] + ".chunk.js";
};